import { useCallback } from 'react';
import { prop } from 'ramda';
import { useDispatch } from 'react-redux';

import { useAppSelector } from '@core/js/store/hooks';
import { storageService } from '@core/js/services/storage.service';
import { useLogout } from '@interlayer/js/hooks/auth/hooks/useLogout';
import { useSmartClosePopups } from 'js/components/common/PopupManager';
import { useLoginPopup } from '@interlayer/js/components/popups/LoginPopup';
import { showLogoutNotificationPopupAction } from '@core/js/components/popups/LogoutNotificationPopup';

/**
 * Core hook:
 * added check for notification action (line 34)
 * added skipLogout[GL-7104] (line 26)
 */

export const useHandleLogoutNotification = () => {
    const logout = useLogout();
    const dispatch = useDispatch();
    const showLoginPopup = useLoginPopup();
    const closePopups = useSmartClosePopups();
    const isLoginAgainPopup = useAppSelector(prop('isLoginAgainPopup'));

    return useCallback(async (): Promise<void> => {
        if (storageService.session.getItem('skipLogout')) {
            return;
        }

        await logout({ isQuiet: true, isManual: false });

        closePopups('logout');

       if (isLoginAgainPopup) {
           dispatch(showLogoutNotificationPopupAction({
               isLoginAgainPopup,
               onAccept: () => showLoginPopup()
           }));
       }
    }, [dispatch, closePopups, logout, isLoginAgainPopup, showLoginPopup]);
};
